import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { Invoices } from '#screens/settings/billing/invoices/Invoices.tsx';
import { FreePlanDetails } from './free/FreePlanDetails.tsx';
import { PaidPlanDetails } from './paid/PaidPlanDetails.tsx';
import styles from './BillingPage.module.css';

export function BillingPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <MainLayout header="Billing">
      <div className={styles.BillingPage}>
        {user.organization.plan === 'pro' ?
          <PaidPlanDetails />
        : null}
        {user.organization.plan === 'free' ?
          <FreePlanDetails />
        : null}
        <Invoices />
      </div>
    </MainLayout>
  );
}
